import { MOKKIE_POSES } from '../../components/ui/mascot/mascots';

/**
 * Poses de Koffi utilisées par les écrans d'authentification, lues dans le
 * catalogue MOKKIE_POSES (une pose par écran, MOKA-214) :
 * connexion « salut », inscription « guide », mot de passe oublié et
 * chargements « réflexion », email envoyé « lecture », succès « bravo ».
 */
export type AuthMascotPose = 'salut' | 'guide' | 'reflexion' | 'lecture' | 'bravo';

export function authMascot(id: AuthMascotPose): string {
  const pose = MOKKIE_POSES.find(p => p.id === id);
  return pose?.file ?? 'assets/images/mokkie/mokkie-salut.png';
}
